import HomePage from "@pages/HomePage/HomePage"
import { useAppStructure } from "@redux/features/appStructure/useAppStructure"
import { createFileRoute } from "@tanstack/react-router"

type MapPageSearch = {
	vessel?: string
}

export const Route = createFileRoute("/_adminPageLayout/map")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): MapPageSearch => {
		//TODO: validate search params here
		return {
			vessel: (search.vessel as string) ?? undefined,
		}
	},
})

function RouteComponent() {
	const { data: appStruct } = useAppStructure()

	return appStruct == null ? <>{"Loading..."}</> : <HomePage props={appStruct} />
}
